(function () {

    "use strict";

    // Routing
    function routingConfiguration($stateProvider) {
        $stateProvider.state("aplicaciones", {
            url: "/aplicaciones",
            template: "<sphforms-aplicaciones></sphforms-aplicaciones>"
        }).state("aplicacion", {
            url: "/aplicacion",
            params: { idEntity: null },
            template: "<sphforms-aplicacion></sphforms-aplicacion>"
        }).state("manuales", {
            url: "/manuales",
            template: "<sphforms-manuales></sphforms-manuales>"
        }).state("manual", {
            url: "/manual",
            params: { idEntity: null },
            template: "<sphforms-manual></sphforms-manual>"
        });
    }

    routingConfiguration.$inject = ["$stateProvider"];

    angular.module("sphforms.formacion")
        .config(routingConfiguration);

}());
